var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: {
        placeholder: "请选择签署方",
        filterable: "",
        "reserve-keyword": "",
        "remote-method": _vm.remoteMethod,
        remote: "",
        loading: _vm.loading,
      },
      on: { change: _vm.handleChange },
      model: {
        value: _vm.signUser,
        callback: function ($$v) {
          _vm.signUser = $$v
        },
        expression: "signUser",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.value,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }